import React from 'react';
import { useReveal } from '../hooks/useReveal';

/**
 * Wraps children in a scroll-triggered reveal.
 *
 * variant: 'up' (default) | 'mask' | 'zoom'
 * delay:   seconds, staggering siblings
 */
export default function Reveal({
  as: Tag = 'div',
  variant = 'up',
  delay = 0,
  className = '',
  style,
  children,
  ...rest
}) {
  const [ref, inView] = useReveal();
  const variantClass = variant === 'up' ? '' : ` reveal--${variant}`;

  return (
    <Tag
      ref={ref}
      className={`reveal${variantClass}${inView ? ' is-in' : ''}${className ? ` ${className}` : ''}`}
      style={{ '--reveal-delay': `${delay}s`, ...style }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

/** Splits a string into words that rise into place one after another. */
export function RevealWords({ text, className = '', step = 0.055, as: Tag = 'span' }) {
  const [ref, inView] = useReveal({ threshold: 0.3 });
  const words = String(text).split(' ');

  return (
    <Tag ref={ref} className={`reveal-words${inView ? ' is-in' : ''} ${className}`} aria-label={text}>
      {words.map((word, i) => (
        <span className="reveal-words__w" key={`${word}-${i}`} aria-hidden="true">
          <span className="reveal-words__i" style={{ transitionDelay: `${i * step}s` }}>
            {word}
          </span>
          {i < words.length - 1 ? ' ' : ''}
        </span>
      ))}
    </Tag>
  );
}
